/**
 * The player's own advantage / disadvantage for the NEXT d20 roll from the sheet (GN, re-pass Н4: «Скрытность из
 * засады», «Помощь» — there was no way to roll with advantage short of a hand-typed /roll).
 *
 * One small store per sheet, shared by the HUD and the full sheet (two React trees): the toggle sets it, useRoll reads
 * it on the next d20 roll (attack, check, skill, save, initiative), sends it to the server — which meets it with the
 * conditions by the rules (shared/systems/dnd5e/roll-mode.ts) — and puts it back to «normal». One roll, not a mode.
 */
import { useSyncExternalStore } from 'react';

export type ManualRollMode = 'normal' | 'advantage' | 'disadvantage';

const modes = new Map<string, ManualRollMode>();
const listeners = new Set<() => void>();
const emit = () => { for (const l of listeners) l(); };

export function getRollMode(sheetId: string): ManualRollMode {
  return modes.get(sheetId) ?? 'normal';
}

export function setRollMode(sheetId: string, mode: ManualRollMode): void {
  if (getRollMode(sheetId) === mode) return;
  if (mode === 'normal') modes.delete(sheetId); else modes.set(sheetId, mode);
  emit();
}

/** Read and reset: the mode applies to one roll. */
export function takeRollMode(sheetId: string): ManualRollMode {
  const m = getRollMode(sheetId);
  if (m !== 'normal') setRollMode(sheetId, 'normal');
  return m;
}

export function useRollMode(sheetId: string | undefined): [ManualRollMode, (m: ManualRollMode) => void] {
  const mode = useSyncExternalStore(
    (l) => { listeners.add(l); return () => { listeners.delete(l); }; },
    () => (sheetId ? getRollMode(sheetId) : 'normal'),
    () => 'normal' as ManualRollMode,
  );
  return [mode, (m: ManualRollMode) => { if (sheetId) setRollMode(sheetId, m); }];
}
